<template>
  <v-card flat tile
    :disabled="loading">
    <v-card-text class="pa-6">
      <al-project-form
        :form-data="project"
      ></al-project-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'project-info-page',
  props: ['project', 'loading'],
  data() {
    return {
      projectInfo: {},
    };
  },
  computed: {
    projectId() { return this.$route.params.projectId; },
    projectName() { return this.$route.params.projectName; },
  },
  methods: {
    noop() {},
    init() {},
  },

  created() {
    this.init();
  },
};
</script>
